import { productCategoryApi } from "apis";
import { Loading } from "components";
import { ErrorStatusType } from "constants/types/common";
import {
  ProductCategoryRequestBodyType,
  ProductCategoryResponse,
} from "constants/types/productCategory";
import { useFormik } from "formik";
import { FORM_IDS } from "pages/ProductCategory/config";
import { FC, useState } from "react";
import { useNotification } from "utils/hooks";
import ProductCategoryFormFields from "../ProductCategoryFormFields/ProductCategoryFormFields";
import { editValidationSchema } from "./config";

type Props = {
  category: ProductCategoryResponse;
  onClose?: () => void;
  mutate?: () => void;
};

const EditForm: FC<Props> = ({ category, onClose, mutate }) => {
  const { notification } = useNotification();
  const [isLoading, setIsLoading] = useState(false);

  const formik = useFormik<ProductCategoryRequestBodyType>({
    initialValues: {
      code: category.code,
      name: category.name,
    },
    validationSchema: editValidationSchema,
    enableReinitialize: true,
    onSubmit: async (values) => {
      setIsLoading(true);
      try {
        await productCategoryApi.update(category.id, values);
        notification.success({ title: "Cập nhật nhóm mặt hàng thành công" });
        onClose?.();
        mutate?.();
      } catch (error: ErrorStatusType | any) {
        notification.error({
          title: "Cập nhật nhóm mặt hàng thất bại",
          message: error?.error?.message,
        });
      }
      setIsLoading(false);
    },
  });

  return (
    <Loading variant="overlay" visible={isLoading}>
      <form id={FORM_IDS.EDIT} onSubmit={formik.handleSubmit}>
        <ProductCategoryFormFields formik={formik} />
      </form>
    </Loading>
  );
};

export default EditForm;
